// extracted by mini-css-extract-plugin
export default {"container":"AddPackage_container__5FXWY","heading":"AddPackage_heading__EzcBO","form":"AddPackage_form__kciVq","buttonContainer":"AddPackage_buttonContainer__1dORM"};